import React, { useEffect, useState } from 'react';

const ChartNav = ({ items }) => {
  const [active, setActive] = useState(items[0]?.id);
  const ids = items.map((item) => item.id).join(',');

  useEffect(() => {
    const sections = ids.split(',').map((id) => document.getElementById(id)).filter(Boolean);
    if (!sections.length || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, { rootMargin: '-120px 0px -55% 0px' });
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [ids]);

  const jump = (event, id) => {
    event.preventDefault();
    const target = document.getElementById(id);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - 118;
    window.scrollTo({ top, behavior: 'smooth' });
    setActive(id);
  };

  if (items.length < 2) return null;
  return (
    <nav className="chart-nav" aria-label="Chart sections">
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <a href={`#${item.id}`} className={active === item.id ? 'active' : ''} onClick={(event) => jump(event, item.id)}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ChartNav;
